import co from 'co';
import OSS from 'ali-oss';

/*
'accessKeyId' => 'LTAI99LwMtSUEb3o',
'accessKeySecret' => 'jGBdHcB0EuLg7qpc92GsPXWHz8lBnh',
'endpoint' => 'oss-cn-beijing.aliyuncs.com',
'bucket' => 'bixinyule',
 */

const OSSConfig = {
    uploadHost: 'http://bixinyule.oss-cn-beijing.aliyuncs.com', //OSS上传地址
    type: 'scs',
    ossParams: {
        region: 'oss-cn-beijing',
        success_action_status: '200', // 默认200
        accessKeyId: 'LTAI99LwMtSUEb3o',
        accessKeySecret: 'jGBdHcB0EuLg7qpc92GsPXWHz8lBnh',
        bucket: 'bixinyule',
    },
}

function random_string(len) {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    let maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}

/**
 *
 * @param event 上传图片的资源路径
 * @param type 图片资源类型
 * @param dir oss要保存的文件夹
 * @returns {OSS文件路径}
 */

function uploadOSS(event, type,dir = 'file/') {
    return new Promise((resolve, reject) => {
        let client = new OSS({
            secure: true,
            region: OSSConfig.ossParams.region,
            accessKeyId: OSSConfig.ossParams.accessKeyId,
            accessKeySecret: OSSConfig.ossParams.accessKeySecret,
            bucket: OSSConfig.ossParams.bucket,
        });
        let file;

        console.log(1,event);

        file = event;

        if (type == 0) {
            file = event;
        } else {
            file = event.target.files[0];
        }

        let randomName = `${dir}${random_string(6)}_${file.name}`;
        co(function* () {
            let result = yield client.multipartUpload(randomName, file);
            console.log(`${OSSConfig.uploadHost}/${result.name}`);
            resolve(`${OSSConfig.uploadHost}/${result.name}`);
        }).catch(function (err) {
            console.log(err);
            reject(err);
        });
    });
}

export { uploadOSS }
